import React, { Fragment, useRef, useState, useEffect } from 'react';
import { FiX } from 'react-icons/fi';
import { useBookletCoupons } from '../../context/BookletCouponsContext';

const { REACT_APP_IMAGE_BASE_URL } = process.env;

interface LogoManagerProps {
  closeLogoManager: () => void;
}

const LogoManager: React.FC<LogoManagerProps> = ({ closeLogoManager }) => {
  const { visibleCompanies, setVisibleCompanies } = useBookletCoupons();
  const [companies, setCompanies] = useState(visibleCompanies);
  const [dragOverIndex, setDragOverIndex] = useState<number | null>(null);
  const gridRef = useRef<HTMLDivElement>(null);

  // Sync local companies state with visibleCompanies when it changes
  useEffect(() => {
    setCompanies(visibleCompanies);
  }, [visibleCompanies]);

  const handleDragStart = (e: React.DragEvent, index: number) => {
    e.dataTransfer.setData('text/plain', index.toString());
  };

  const handleDragOver = (e: React.DragEvent, index: number) => {
    e.preventDefault();
    setDragOverIndex(index);
  };

  const handleDragLeave = () => {
    setDragOverIndex(null);
  };

  const handleDrop = (e: React.DragEvent, targetIndex: number) => {
    e.preventDefault();
    const sourceIndex = parseInt(e.dataTransfer.getData('text/plain'));
    const newCompanies = [...companies];

    // Move the logo to the new position
    const [movedCompany] = newCompanies.splice(sourceIndex, 1);
    newCompanies.splice(targetIndex, 0, movedCompany);

    setCompanies(newCompanies);
    setVisibleCompanies(newCompanies);
    setDragOverIndex(null);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content logo-manager-modal">
        <div className="modal-header">
          <h3>Hantera logotyper</h3>
          <button className="close-btn" onClick={closeLogoManager} title="Stäng">
            <FiX size={20} />
          </button>
        </div>
        <div className="logo-grid" ref={gridRef}>
          {companies.map((company, index) => (
            company?.logoURL && (
              <Fragment key={company._id}>
                <div
                  className={`logo-item ${dragOverIndex === index ? 'drag-over' : ''}`}
                  draggable
                  onDragStart={(e) => handleDragStart(e, index)}
                  onDragOver={(e) => handleDragOver(e, index)}
                  onDragLeave={handleDragLeave}
                  onDrop={(e) => handleDrop(e, index)}
                >
                  <img
                    src={(REACT_APP_IMAGE_BASE_URL || '') + company.logoURL}
                    alt={company.name}
                    className="company-logo"
                  />
                </div>
              </Fragment>
            )
          ))}
        </div>
      </div>
    </div>
  );
};

export default LogoManager;

